<template>
    <div class="app-container demonstrate">
        <div style="margin-bottom: 10px;">
            <el-tabs v-model="active" @tab-click="onClick" type="card" class="cardTabs">
                <el-tab-pane label="库存查询" name="0"></el-tab-pane>
                <el-tab-pane label="操作记录" name="1"></el-tab-pane>
            </el-tabs>
        </div>
        <list ref="list" v-if="active == 0" />
        <list2 ref="list2" v-if="active == 1">
            <template slot="toolbar-right">
                <el-button class="filter-item" type="primary" @click="create" v-if="$permission.canWrite()" icon="el-icon-plus">添加</el-button>
                <el-button class="filter-item" type="danger" @click="delRows" v-if="$permission.canDel()">删除</el-button>
                <el-button type="success" plain @click="onExport">导出</el-button>
            </template>
            <el-table-column slot="column" label="操作" fixed="right" align="center" width="90">
                <template slot-scope="{row}">
                    <el-button type="text" size="medium" @click="editById(row.PlaceId)" v-if="$permission.canEdit()&&row.Status!=3" icon="el-icon-edit" title="编辑"></el-button>
                    <el-button type="text" size="medium" v-if="$permission.canRead()" @click="details(row)" icon="el-icon-document" title="查看"></el-button>
                    <el-button type="text" size="medium" @click="delRow(row.PlaceId)" icon="el-icon-delete" v-if="$permission.canDel()&&row.Status!=3" title="删除"></el-button>
                </template>
            </el-table-column>
        </list2>
        <details-dialog ref="detailsDialog" @close-saved="reload"></details-dialog>
        <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>  
    </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/operate/activeplace/list";
import list2 from "@/components/operate/activeplace/list2";
import detailsDialog from '@/components/operate/activeplace/detailsDialog'
import editDialog from "@/components/operate/activeplace/editDialog";

export default {
    name: "activeplace",
    mixins: [curdMixins],
    components: {
        list,
        list2,
        editDialog,
        detailsDialog
    },
    data() {
        return {
            active: "0",
        }
    },
    methods: {
        reload() {
            if (this.active == '0') {
                this.$refs.list.reload();
            } else if (this.active == '1') {
                this.$refs.list2.reload();
            }
        },
        onClick(e) {
            this.active = e.name;
            this.$nextTick(e => {
                if (this.active == '0') {
                    this.$refs.list.reload();
                } else if (this.active == '1') {
                    this.$refs.list2.reload();
                }
            })
        },
        details(row) {
            this.$refs.detailsDialog.openEditById(row.PlaceId);
        },
        delRow(id) {
            this.$confirm("确认删除所选的数据吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$refs.list2.delRange([id]);
                })
                .catch(() => { });
        },
        delRows() {
            let rows = this.$refs.list2.getCheckedRows();
            if (rows.length == 0) {
                this.$message.warning("请选择要删除的数据");
                return;
            }
            this.$confirm("确认删除所选的数据吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let ids = rows.map((item) => {
                        return item.PlaceId;
                    });
                    this.$refs.list2.delRange(ids);
                })
                .catch(() => { });
        },
        onExport() {
            this.$refs.list2.onExport();
        },
    },
};
</script>
<style lang="scss">
.demonstrate .el-tabs .el-tabs__header {
    margin: 0 !important;
}
</style>